import { getVerbalColors } from 'helpers'
const tBodyRowHeight = 80
const tHeadRowHeight = 34

export {
    tBodyRowHeight,
    tHeadRowHeight
}
export 

/**
 *
 */
const style = theme => {
    const { colors } = theme['foundations-library']
    const verbalColors = getVerbalColors(colors)
    const commonCellStyle = {
        height: tBodyRowHeight,
        boxShadow: '0px -1px 0px 0px rgba(133, 146, 154, 0.2) inset',
        '& td': {
            padding: '0 6px'
        }
    }

    return {
        tableContainer: {
            overflowX: 'auto'
        },
        table: {
            width: '100%'
        },
        tHead: {
            '& tr': {
                height: tHeadRowHeight,
                borderRadius: '5px',
                '& th': {
                    paddingRight: 20,
                    paddingLeft: 10,
                    backgroundColor: (color) => verbalColors[color] || verbalColors['neutral-50']
                }
            },
            '& th': {
                padding: '0 6px',
                whiteSpace: 'nowrap',
                '&:first-child': {
                    borderRadius: '5px 0 0 5px'
                },
                '&:last-child': {
                    borderRadius: 0
                }
            }
        },
        tBody: {
            '& tr': {
                ...commonCellStyle
            },
            '& tr:last-child': {
                boxShadow: 'none'
            }
        },
        tFoot: {
            ...commonCellStyle,
            '& tr': {
                boxShadow: '0px 1px 0px 0px rgba(133, 146, 154, 0.2) inset'

            }
        }
    }
}

export default style
